const Spinner = () => {
  return <span className='loader' />;
};

export default Spinner;
